module.exports = __webpack_public_path__ + "img/emp4-2.6c08c807.jpg";